/* React Query rond de datalaag van de opvolgpunten. De client is de gewone CRM-client (sessie van
 * de ingelogde gebruiker); de datalaag zelf krijgt hem als argument. */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import {
  haalMijnOpvolging, haalOpvolgingVanProject, haalVerstuurdeStukken, koppelAanProject, lokaleDag, telMijnOpvolging, zetOpgevolgd, zetOpvolgStatus,
  type OpvolgClient, type Opvolgpunt, type OpvolgStatus,
} from './data/opvolging';

/* De gegenereerde types kennen de tabellen van na types.ts niet. */
const client = supabase as unknown as OpvolgClient;
const o = (...k: unknown[]) => ['opvolging', ...k];

export const useMijnOpvolging = (userId: string | undefined) =>
  useQuery({ queryKey: o('mijn', userId), queryFn: () => haalMijnOpvolging(client, userId!), enabled: Boolean(userId), staleTime: 60_000 });

export const useOpvolgTelling = (userId: string | undefined) =>
  useQuery({ queryKey: o('telling', userId), queryFn: () => telMijnOpvolging(client, userId!), enabled: Boolean(userId), staleTime: 60_000 });

export const useProjectOpvolging = (projectId: string | undefined) =>
  useQuery({ queryKey: o('project', projectId), queryFn: () => haalOpvolgingVanProject(client, projectId!), enabled: Boolean(projectId), staleTime: 60_000 });

/** Welke bestanden uit de Projectmap zijn verstuurd, aan wie en wanneer (ADR 0030). */
export const useVerstuurdeStukken = (projectId: string | undefined) =>
  useQuery({ queryKey: o('verstuurd', projectId), queryFn: () => haalVerstuurdeStukken(client, projectId!), enabled: Boolean(projectId), staleTime: 60_000 });

export function useOpvolgActies() {
  const qc = useQueryClient();
  const ververs = () => qc.invalidateQueries({ queryKey: o() });
  return {
    status: useMutation({ mutationFn: (v: { id: string; status: OpvolgStatus }) => zetOpvolgStatus(client, v.id, v.status), onSuccess: ververs }),
    /** Gebeld of gemaild: vandaag, of `ongedaan` om het weer weg te halen. */
    opgevolgd: useMutation({ mutationFn: (v: { id: string; ongedaan?: boolean }) => zetOpgevolgd(client, v.id, v.ongedaan ? null : lokaleDag(new Date())), onSuccess: ververs }),
    koppel: useMutation({
      mutationFn: (v: { punt: Pick<Opvolgpunt, 'id' | 'eigenaar_id' | 'draad_id'>; projectId: string | null }) => koppelAanProject(client, v.punt, v.projectId),
      onSuccess: ververs,
    }),
  };
}
